"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderError = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _basic_provider = _interopRequireDefault(require("./_basic_provider"));

var _error = require("./error");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ProviderError =
/*#__PURE__*/
function (_BasicError) {
  (0, _inherits2.default)(ProviderError, _BasicError);

  function ProviderError(error, data, name) {
    (0, _classCallCheck2.default)(this, ProviderError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProviderError).call(this, 'Providers API Error', error, data, name));
  }

  return ProviderError;
}(_error.BasicError);

exports.ProviderError = ProviderError;

var ContactsProviderApi =
/*#__PURE__*/
function (_BasicProviderApi) {
  (0, _inherits2.default)(ContactsProviderApi, _BasicProviderApi);

  function ContactsProviderApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl,
        providersAccountId = _ref.providersAccountId,
        httpGatewayUrl = _ref.httpGatewayUrl,
        globalCache = _ref.globalCache,
        sendWSMessage = _ref.sendWSMessage;
    (0, _classCallCheck2.default)(this, ContactsProviderApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactsProviderApi).call(this, {
      userTokenFactory: userTokenFactory,
      sdkApiUrl: sdkApiUrl,
      providersAccountId: providersAccountId,
      httpGatewayUrl: httpGatewayUrl
    }));
    _this._contactBooksCache = {};
    _this.globalCache = globalCache;

    if (globalCache && !global._contactBooksCache) {
      global._contactBooksCache = {};
    }

    _this.sendWSMessage = sendWSMessage;
    return _this;
  }

  (0, _createClass2.default)(ContactsProviderApi, [{
    key: "_callApi",
    value: function () {
      var _callApi2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref2) {
        var method, _ref2$path, path, payload, _ref2$queryParams, queryParams, _ref2$errorData, errorData, errorName;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                method = _ref2.method, _ref2$path = _ref2.path, path = _ref2$path === void 0 ? '' : _ref2$path, payload = _ref2.payload, _ref2$queryParams = _ref2.queryParams, queryParams = _ref2$queryParams === void 0 ? {} : _ref2$queryParams, _ref2$errorData = _ref2.errorData, errorData = _ref2$errorData === void 0 ? {} : _ref2$errorData, errorName = _ref2.errorName;

                if (!this.sendWSMessage) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", this._callApiWS({
                  method: method,
                  path: path,
                  payload: payload,
                  queryParams: queryParams,
                  errorData: errorData,
                  errorName: errorName
                }));

              case 3:
                return _context.abrupt("return", this._callApiHttp({
                  method: method,
                  path: path,
                  payload: payload,
                  queryParams: queryParams,
                  errorData: errorData,
                  errorName: errorName
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _callApi(_x) {
        return _callApi2.apply(this, arguments);
      }

      return _callApi;
    }()
  }, {
    key: "_callApiHttp",
    value: function () {
      var _callApiHttp2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref3) {
        var method, path, payload, queryParams, errorData, errorName, _ref4, headers, bookId, avoidBook, responseBook, _ref5, responseBody;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                method = _ref3.method, path = _ref3.path, payload = _ref3.payload, queryParams = _ref3.queryParams, errorData = _ref3.errorData, errorName = _ref3.errorName;
                _context2.next = 3;
                return this.getHeaders();

              case 3:
                _ref4 = _context2.sent;
                headers = _ref4.headers;
                bookId = _lodash.default.has(queryParams, 'bookId') ? _lodash.default.get(queryParams, 'bookId') : _lodash.default.has(payload, 'bookId') ? _lodash.default.get(payload, 'bookId') : undefined;
                avoidBook = _lodash.default.get(queryParams, 'avoidBook', false);
                responseBook = this.contactBooksCache["".concat(bookId || 'Default')] || {};

                if (!(_lodash.default.isEmpty(responseBook) && !avoidBook)) {
                  _context2.next = 20;
                  break;
                }

                _context2.prev = 9;
                _context2.next = 12;
                return this.axios({
                  method: 'get',
                  url: '/contacts-books',
                  params: bookId ? {
                    bookId: bookId,
                    projection: JSON.stringify(['source'])
                  } : {
                    name: 'Default',
                    projection: JSON.stringify(['source'])
                  },
                  headers: headers
                });

              case 12:
                responseBook = _context2.sent;
                responseBook = responseBook.data;
                bookId ? this.contactBooksCache[bookId] = responseBook : this.contactBooksCache.Default = responseBook;
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](9);
                throw new ProviderError(_context2.t0, _objectSpread({
                  statusCode: _lodash.default.get(_context2.t0, ['response', 'status']),
                  config: _lodash.default.get(_context2.t0, ['response', 'config']),
                  headers: _lodash.default.get(_context2.t0, ['response', 'headers'])
                }, errorData), errorName);

              case 20:
                _context2.prev = 20;
                _context2.next = 23;
                return this.axios({
                  method: method,
                  url: (responseBook.source || '') + path,
                  data: JSON.stringify(payload),
                  params: _lodash.default.mapValues(queryParams, function (value) {
                    return _lodash.default.isArray(value) ? JSON.stringify(value) : value;
                  }),
                  headers: headers
                });

              case 23:
                _ref5 = _context2.sent;
                responseBody = _ref5.data;
                return _context2.abrupt("return", responseBody);

              case 28:
                _context2.prev = 28;
                _context2.t1 = _context2["catch"](20);
                throw new ProviderError(_context2.t1, _objectSpread({
                  statusCode: _lodash.default.get(_context2.t1, ['response', 'status']),
                  config: _lodash.default.get(_context2.t1, ['response', 'config']),
                  headers: _lodash.default.get(_context2.t1, ['response', 'headers'])
                }, errorData), errorName);

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 17], [20, 28]]);
      }));

      function _callApiHttp(_x2) {
        return _callApiHttp2.apply(this, arguments);
      }

      return _callApiHttp;
    }()
  }, {
    key: "sendWSMsg",
    value: function () {
      var _sendWSMsg = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref6) {
        var headers, method, path, payload, queryParams, errorData, errorName, message, timeoutError, response, code, body, errorMessage, err;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                headers = _ref6.headers, method = _ref6.method, path = _ref6.path, payload = _ref6.payload, queryParams = _ref6.queryParams, errorData = _ref6.errorData, errorName = _ref6.errorName;
                message = {
                  event: {
                    target: this.providersAccountId,
                    name: "http/".concat(method, "/").concat(path),
                    params: {
                      method: method,
                      path: path,
                      request: {
                        method: method,
                        headers: headers,
                        queryParams: queryParams,
                        body: payload
                      }
                    }
                  }
                };
                _context3.prev = 2;
                timeoutError = new Error('Timeout');
                timeoutError.response = {
                  config: {
                    method: method,
                    baseURL: 'WS',
                    url: path,
                    data: payload,
                    params: queryParams
                  }
                };
                _context3.next = 7;
                return this.sendWSMessage({
                  message: message,
                  timeoutError: timeoutError
                });

              case 7:
                response = _context3.sent;
                code = _lodash.default.get(response, ['result', 'code']);
                body = _lodash.default.get(response, ['result', 'body']);

                if (!(code >= 400)) {
                  _context3.next = 15;
                  break;
                }

                errorMessage = _lodash.default.get(body, ['error'], 'API Error');
                err = new Error(errorMessage);
                err.response = {
                  status: code,
                  data: body,
                  headers: _lodash.default.get(response, ['result', 'headers']),
                  config: {
                    method: method,
                    baseURL: 'WS',
                    url: path,
                    data: payload,
                    params: queryParams
                  }
                };
                throw err;

              case 15:
                return _context3.abrupt("return", body);

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](2);
                throw new ProviderError(_context3.t0, _objectSpread({
                  statusCode: _lodash.default.get(_context3.t0, ['response', 'status']),
                  config: _lodash.default.get(_context3.t0, ['response', 'config']),
                  headers: _lodash.default.get(_context3.t0, ['response', 'headers'])
                }, errorData), errorName);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 18]]);
      }));

      function sendWSMsg(_x3) {
        return _sendWSMsg.apply(this, arguments);
      }

      return sendWSMsg;
    }()
  }, {
    key: "_callApiWS",
    value: function () {
      var _callApiWS2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref7) {
        var method, path, payload, queryParams, errorData, errorName, _ref8, headers, bookId, responseBook, _queryParams, _method, _path;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                method = _ref7.method, path = _ref7.path, payload = _ref7.payload, queryParams = _ref7.queryParams, errorData = _ref7.errorData, errorName = _ref7.errorName;
                _context4.next = 3;
                return this.getHeaders();

              case 3:
                _ref8 = _context4.sent;
                headers = _ref8.headers;
                headers = _lodash.default.mapKeys(headers, function (val, key) {
                  return _lodash.default.toLower(key);
                });
                bookId = _lodash.default.has(queryParams, 'bookId') ? _lodash.default.get(queryParams, 'bookId') : _lodash.default.has(payload, 'bookId') ? _lodash.default.get(payload, 'bookId') : undefined;
                responseBook = this.contactBooksCache["".concat(bookId || 'Default')];

                if (!_lodash.default.isEmpty(responseBook)) {
                  _context4.next = 16;
                  break;
                }

                _queryParams = bookId ? {
                  bookId: bookId,
                  projection: JSON.stringify(['source'])
                } : {
                  name: 'Default',
                  projection: JSON.stringify(['source'])
                };
                _method = 'get';
                _path = 'contacts-books';
                _context4.next = 14;
                return this.sendWSMsg({
                  headers: headers,
                  method: _method,
                  path: _path,
                  payload: payload,
                  queryParams: _queryParams,
                  errorData: errorData,
                  errorName: errorName
                });

              case 14:
                responseBook = _context4.sent;
                bookId ? this.contactBooksCache[bookId] = responseBook : this.contactBooksCache.Default = responseBook;

              case 16:
                path = _lodash.default.replace(responseBook.source || '', /^\//, '') + path;
                _context4.next = 19;
                return this.sendWSMsg({
                  headers: headers,
                  method: method,
                  path: path,
                  payload: payload,
                  queryParams: queryParams,
                  errorData: errorData,
                  errorName: errorName
                });

              case 19:
                return _context4.abrupt("return", _context4.sent);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _callApiWS(_x4) {
        return _callApiWS2.apply(this, arguments);
      }

      return _callApiWS;
    }()
  }, {
    key: "contactBooksCache",
    get: function get() {
      return this.globalCache ? global._contactBooksCache : this._contactBooksCache;
    },
    set: function set(contactsBook) {
      if (this.globalCache) {
        global._contactBooksCache = contactsBook;
      } else {
        this._contactBooksCache = contactsBook;
      }
    }
  }]);
  return ContactsProviderApi;
}(_basic_provider.default);

var _default = ContactsProviderApi;
exports.default = _default;